
    import Component from "vue-class-component";
    import {
        ApiException,
        EducationalQualificationDetailsModel,
        EducationalQualificationModel,
        EducationalQualificationOptions,
        factory,
        QualificationActions,
        QualificationsClient
    } from "@/api-client";
    import {QualificationAddBase} from "@/features/documents/qualifications/views/QualificationAddBase";
    import FormLayout from "@/features/personProfile/components/FormLayout.vue";
    import FileUploader from "@/components/FileUploader.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import CheckboxInput from "@/features/shared/components/CheckboxInput.vue";
    import {Prop} from "vue-property-decorator";
    import EducationalQualificationUpsertForm from "@/features/documents/qualifications/components/EducationalQualificationUpsertForm.vue";

    interface Props {
        seafarerId: string;
        qualificationPreloadedActions: QualificationActions;
        options: EducationalQualificationOptions;
        existingQualification: EducationalQualificationDetailsModel;
    }

    @Component({
        components: {
            FileUploader,
            FormLayout,
            LabelOptional,
            CheckboxInput,
            EducationalQualificationUpsertForm
        },
        async beforeRouteEnter(to, from, next : NavigationGuardNext<EducationalQualificationEdit>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            const qualificationId = to.params.id
            Promise.all([
                new QualificationsClient().availableActions(props.seafarerId, qualificationId),
                new QualificationsClient().educationalOptions(),
                new QualificationsClient().getEducationalQualification(qualificationId),
            ]).then(values => {
                props.qualificationPreloadedActions = values[0];
                props.options = values[1];
                props.existingQualification = values[2];
                next();
            }).catch(e => next(e))
        }
    })
    export default class EducationalQualificationEdit extends QualificationAddBase<EducationalQualificationModel> {
        @Prop({required: true})
        qualificationPreloadedActions!: QualificationActions;

        @Prop({required: true})
        existingQualification!: EducationalQualificationDetailsModel;

        @Prop({required: true})
        seafarerId!: string;

        @Prop({required: true})
        options!: EducationalQualificationOptions;

        initialModel: EducationalQualificationModel = factory.create(EducationalQualificationModel);
        isCreated = false;

        async created() {
            this.initialModel = new EducationalQualificationModel({
                ...this.existingQualification,
                existingFiles: this.existingQualification.files,
                addedFiles: [],
                removedFiles: []
            });
            this.isCreated = true;
        }

        async editQualification(model: EducationalQualificationModel) {
            /* QualificationAddBase already has a submit function, but it only does "add", and
               it is not used here (shouldn't be either, it doesn't do "edit").
               Best would be to make a similar "edit" function in Base, but due to time limitations
               there is a duplicated "editQualification" function both here and TrainingQualificationEdit.vue :) */

            return await new QualificationsClient().edit(this.existingQualification.id, model)
            .then(async result => {
                const route = this.returnRoute
                ? this.returnRoute
                : { name: "educational-details" };

                route.params = {
                    ...route.params,
                    seafarerId: this.existingQualification.seafarerId,
                    id: this.existingQualification.id
                }

                await this.$router.replace(route);
            });
        }
    }
